/* eslint-disable react/display-name */
import React, { ReactElement } from 'react';
import { getTelegramWebApp, isTelegramKVersion } from '@24i/nxg-sdk-higgs/src/utils';

import View from './View';
import { useViewModel } from './viewModel';
import { GenreScreenProps, GenreViewModelProps } from './types';
import { createWebHeaderProps } from '../../utils/headerUtils';

export const GenreScreen = {
    Main: (props: GenreScreenProps): ReactElement => {
        const viewModelProps: GenreViewModelProps = useViewModel(props);
        const isTelegramK = isTelegramKVersion();
        const TelegramWebApp = getTelegramWebApp();
        const isFullscreen = TelegramWebApp?.isFullscreen;

        // Format the selected genre for display
        const selectedGenre = Array.isArray(viewModelProps.selectedGenre)
            ? viewModelProps.selectedGenre.join(', ')
            : viewModelProps.selectedGenre;

        // Create header props using our utility function
        const webHeaderProps = createWebHeaderProps(
            selectedGenre || undefined,
            selectedGenre || 'Genres'
        );

        // Add additional props specific to GenreScreen
        const enhancedHeaderProps = {
            ...webHeaderProps,
            // Always use sticky variant for consistent behavior
            variant: 'sticky' as const,
            // Add a custom flag to identify Telegram non-fullscreen case
            isTelegramNonFullscreen: isTelegramK && !isFullscreen,
        };

        return <View {...viewModelProps} {...enhancedHeaderProps} />;
    },
    useViewModel,
    View,
};

// For backward compatibility
export default GenreScreen;
